import Actions from '.';
import { get, put } from '../../../utils/api';
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from '../../../constants';

const UPLOADED_ORDER_TYPE = '1'

// const filterUploadedOrder = data => data.filter(order => order.orderType !== UPLOADED_ORDER_TYPE)  || []

const getOrders = () => (async (dispatch, getState) => {
    const { orders: { status } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`/order/order-list?status=${status}&limit=${DEFAULT_RECORD_LIMIT}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response.orders,
                nextPageToken: data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.statusCode !== 200 ? (data.message || API_ERROR_MESSAGE) : '',
                list: [],
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
            nextPageToken: null,
        }));
    }
});

const loadMoreOrders = () => (async (dispatch, getState) => {
    const { orders: { nextPageToken, list } } = getState();
    console.log(list);

    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`order/order-list?nextPageToken=${nextPageToken}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: [...list, ...data.response.orders],
                nextPageToken: data.response?.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});

const searchOrders = () => (async (dispatch, getState) => {
    const {orders:{ searchText }} = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`order/order-list?searchText=${searchText}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(
              Actions.updateProperties({
                loading: false,
                error: "",
                success: true,
                list: data.response?.orders || [],
                nextPageToken: null,
              })
            );
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});

const getOrderDetails = id => (async (dispatch) => {
    dispatch(Actions.updateProperty('loadingData', true));
    try {
        const data = await get(`order/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
               loadingData: false,
               data: data.response,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingData: false,
                error: data.message || API_ERROR_MESSAGE,
                showDetails: false,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            showDetails: false,
        }));
    }
});

const updateStatus = (body, isDetailsPage) => (async dispatch => {
    dispatch(Actions.updateProperty('loadingData', true));
    try {
        const data = await put(`order`, body);
        if (data.statusCode === 200) {
            if (isDetailsPage) {
                dispatch(Actions.updateProperties({
                    loadingData: false,
                }));
                dispatch(getOrderDetails(body.orderId))
            } else {
                dispatch(Actions.updateProperties({
                    loadingData: false,
                    showDetails: false,
                    data: {},
                }));
                dispatch(getOrders())
            }
        } else {
            dispatch(Actions.updateProperties({
                loadingData: false,
                error: data.message || API_ERROR_MESSAGE,
                showDetails: false,
            })); 
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            showDetails: false,
            data: {},
        }));
    }
})

export default {
    getOrders,
    loadMoreOrders,
    getOrderDetails,
    updateStatus,
    searchOrders
}